import { useState } from "react";
import { useGetGoldebBallInfo } from "../GoldenBallThrophyScreen/hooks/useGetGoldenBallInfo";
import GridPlayers from "../GoldenBallVotedScreen/components/GridPlayers";
import { useGetPlayersNominated } from "../GoldenBallVotedScreen/hooks/useGetPlayerNominated";
import { useHandlerVoting } from "../GoldenBallVotedScreen/hooks/useHandlerVoting";
import ConfirmPointModal from "./components/ConfirmPointModal";
import GridPlayersSeven from "./components/GridPlayerSeven";
import './index.css'
import { getId } from "../../utils/getId";
import { useHandlerSevenVoting } from "../GoldenBallVotedScreen/hooks/useHandlerSevenVoting";
import { useVoteRedirect } from "../GoldenBallVotedScreen/hooks/useVoteRedirect";
import HeaderGoldenball from "../GoldenBallVotedScreen/components/HeaderGoldenball";
import DescriptionLabel from "./components/DescriptionLabel";

const BestSevenVotedScreen = () =>{

 
        const { goldenBallInfo, isLoading } = useGetGoldebBallInfo({phase:'nominates'});
        const id = getId(3)
        const keyPhase = `playersVoted-${'nominates'}-${id}`
        const { allPlayers } = useGetPlayersNominated({phase:'nominate'})
        console.log('@@allPlayers', allPlayers)
        const { handleVoteBySevenPlayer, hasSpecialVote, isVoting, playersVoted, 
            selectedPlayer, setSelectedPlayer, pointInfo, setPointInfo, pointsSelected, playerVotedIds } = 
            useHandlerSevenVoting({
            goldenBallInfo: goldenBallInfo, 
            phase:'nominate'
        })

        useVoteRedirect({
            goldenBallInfo, 
            hasSpecialVote,
            playersVoted: pointInfo?.playersVoted || [],
            targetPath: 'graphScreenSevenPhaseOne',
            numberVoted: 10,

        })


    return (
        <div className="best-seven-voted-screen-container">
            <div className="best-seven-voted-screen-subcontainer">
                <HeaderGoldenball info={goldenBallInfo} isSpecialVote={hasSpecialVote} />
                <DescriptionLabel text={`Puedes votar por ${10 - playerVotedIds?.size} jugadores`} />
                <GridPlayersSeven 
                players={allPlayers?.filter(player => !playerVotedIds.has(player._id))} 
                vote={setSelectedPlayer} />

                {selectedPlayer && <ConfirmPointModal
                currentPoint={pointInfo.currentPoint}
                pointAvaible={pointInfo.pointAvaible?.filter(point => !pointsSelected.has(point))}
                selectedPoints={pointInfo.selectedPoints}
                selectPoint={setPointInfo}
                selectedPlayers={pointInfo.playersVoted}
                vote={handleVoteBySevenPlayer} 
                player={selectedPlayer}
                cancel={() => setSelectedPlayer(null)} 
                keyPhase={keyPhase}
                
                />}

            </div>
        </div>
    )
}

export default BestSevenVotedScreen